
//InsurancePortalapi_Local
// const BASE_URL = "https://localhost:7232/";


//const Recording_URL = "http://localhost:9000/";


// Apna Clinic
// const Login_Url = "http://localhost:3010/";


const Auth_KEY = "a3f8c2d1e4b7a9f0c3d2e1b4a5f6c7d8e9f";


// Live BaseUrls

//InsurancePortalapi
const BASE_URL = "https://webdocinsuranceportalapi.webddocsystems.com/";

// Apna Clinic
const Login_Url = "https://apnaclinic.apiintegration.webdocoffice.com.pk/";

//Easypaisa_recording
// 
const Recording_URL = "https://reportingeasypaisaapi.webddocsystems.com/";

export { BASE_URL, Login_Url, Auth_KEY, Recording_URL };
